import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPieChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPieChart2"><Path d="M21.5 9.5C20.9823 5.8806 18.1194 3.01771 14.5 2.5V9.5H21.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M19.5 13C19.5 17.6944 15.6944 21.5 11 21.5C6.30558 21.5 2.5 17.6944 2.5 13C2.5 8.30558 6.30558 4.5 11 4.5C11.1678 4.5 11.3346 4.50487 11.5 4.51446V12.5H19.4855C19.4951 12.6654 19.5 12.8322 19.5 13Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconPieChart2;
